import gql from 'graphql-tag'

export default gql`
  query Navigation($path: String!, $country: String!) {
    cfContentPageCollection(
      where: { AND: [{ path: $path }, { country_contains_all: [$country] }] }
      limit: 1
    ) {
      items {
        sys {
          id
        }
        navigationMenu
        title
      }
    }
  }
`
